import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, Link, useParams } from "react-router-dom";

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import { Button, Card } from '@mui/material';

import { endpoints } from "../../services/apiurl";

import Input from "../UI/Input/Input";
import PageTitle from "../UI/PageTitle";
import TextAreaInput from "../UI/Input/TextAreaInput";


import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import FileUploader from "../FileUploader";


const AddOutletDetails = () => {
    let history = useHistory();
    const [outlet, setOutlet] = useState({
        outlet_name: '',
        restro_id: '',
        outlet_id: '',
        airmenu_id:'',
        contact:'',
        email:'',
        address: '',
       description: '',
       instagram_url: '',
       facebook_url: '',
       twitter_url	:'',
       status: '',
              
    });
    const [selectedFile, setSelectedFile] = useState(null);


    const handleFileSelectSuccess = (file) => {
        setSelectedFile(file);
      };
    
      const handleFileSelectError = ({ error }) => {
        alert(error);
      };
    const [loading, setloading] = useState(false);
    const [rest, setRest] = useState([]);

    const { description,instagram_url,facebook_url,twitter_url,address,outlet_name,restro_id,outlet_id,airmenu_id,contact,email,status } = outlet;

    const onInputChange = e => {
        setOutlet({ ...outlet, [e.target.name]: e.target.value })
        console.log(outlet);
    }

    useEffect(() => {
        getRestaurentsDropDown();
    }, []);


    const getRestaurentsDropDown = async () => {
        await axios.post(endpoints.getRestaurentsDropDown).then((response) => {
            setRest(response.data.data);
        });
    };

    const onSubmit = async e => {
        setloading(true);
        e.preventDefault();
        
        if (!selectedFile) {
            alert('Please select an image');
            setloading(false);  
            return false;
        }
      
        const formData = new FormData();

        formData.append("outlet_name", outlet_name);   
        formData.append("restro_id", restro_id);
        
        formData.append("description", description);
        formData.append("instagram_url", instagram_url);
        formData.append("facebook_url", facebook_url);
        formData.append("twitter_url", twitter_url);
        formData.append("address", address);
     
        formData.append("email", email);
        formData.append("contact", contact);

        formData.append("airmenu_id", airmenu_id);
        formData.append("outlet_id", outlet_id);
        formData.append("status", status);
        formData.append("menu_link", selectedFile);


        await axios.post(endpoints.addOutletDetails, formData).then((response) => {
            setloading(false);
            history.goBack();
        });
    }
    return (
        <div className="ui main">
            <PageTitle title="Add Outlet" linkurl="" linkTitle="" />

            <Card className="px-3 py-3">
                <form className="ui form" onSubmit={e => onSubmit(e)} encType="multipart/form-data">
                    <div className="row">
                        {/* <div className="col col-6">
                            <label>Restaurents </label>
                            <select name="restro_id" required className="form-control" onChange={e => onInputChange(e)} >
                                <option value="">Select Restaurents</option>
                                {rest.map((e, key) => {
                                    return <option key={key} value={e.id}>{e.name}</option>;
                                })}
                            </select>
                        </div> */}

                        <Input id="outlet_name" label="Outlet Name" type="text" name="outlet_name" place="outlet_name" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={outlet_name} class="col col-6"
                        />
                  <Input id="restro_id" label="restro_id" type="number" name="restro_id" place="restro_id" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={restro_id} class="col col-6"
                        />

                    </div>
                    <div className="row">
                        <Input id="airmenu_id" label="Airmenu_id" type="number" name="airmenu_id" place="airmenu_id" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={airmenu_id} class="col col-6"
                        />
                        <Input id="outlet_id" label="outlet_id" type="number" name="outlet_id" place="outlet_id" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={outlet_id} class="col col-6"
                        />
                        </div>

                   
                    <div className="row">
                        <Input id="instagram_url" label="Instagram Url" type="text" name="instagram_url" place="instagram_url" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={instagram_url} class="col col-6"
                        />
                        <Input id="facebook_url" label="Facebook Url" type="text" name="facebook_url" place="facebook_url" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={facebook_url} class="col col-6"
                        />
                        </div> 

                        <div className="row">
                        <Input id="twitter_url" label="Twitter Url" type="text" name="twitter_url" place="twitter_url" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={twitter_url} class="col col-6"
                        />
                        <Input id="address" label="address" type="text" name="address" place="address" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={address} class="col col-6"
                        />
                        </div>
                        <div className="row">
                        <Input id="contact" label="Contact" type="text" name="contact" place="contact" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={contact} class="col col-6"
                        />
                        <Input id="email" label="Email" type="text" name="email" place="email" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={email} class="col col-6"
                        />
                        </div>

                        <div className="row">
                        <TextAreaInput id="description" label="description" type="text" name="description" place="description" onChange={(e) => onInputChange(e)}
                            requiredInput="required" value={description} class="col col-6"
                        />
                       <div className="col col-6">
                            <label>Status</label>
                            <select name="status" required className="form-control" onChange={e => onInputChange(e)} >
                                <option value="">Select Status</option>
                                <option value="2">InActive</option>
                                <option value="1">Active</option>
                            </select>
                        </div>
                        </div>
                        <div className="col col-4">
                            <label>Menu Link</label>
                            

                            <FileUploader
                             onFileSelectSuccess={handleFileSelectSuccess}
                             onFileSelectError={handleFileSelectError}
                           />
                     
                           {selectedFile && (
                             <div>
                               <p>Preview:</p>
                               <img
                                 src={URL.createObjectURL(selectedFile)}
                                 alt="Selected Logo"
                                 style={{ maxWidth: '100%', height: 'auto' }}
                               />
                             </div>
                           )}
                                           
                        </div>
                    <div className="row">
                        <div className="col col-6">
                            <div className="mt-3">
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                            </div></div></div>


                </form>
            </Card>
        </div>
    );

}

export default AddOutletDetails;


